import React, { useEffect, useState } from "react";
import { Avatar, Card, List, Skeleton } from "antd";
import { accountAtom, accountsAtom } from "src/store";
import { useAtom } from "jotai";
import { SolutionOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { routes } from "src/data/routes";
import { getCustomerDetails } from "src/api/http/account";
import { usePageTracking } from "src/hooks/tracking-page.hook";

const App: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [list] = useAtom(accountsAtom);
  const [account, setAccount] = useAtom(accountAtom);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { trackPage } = usePageTracking();
  useEffect(() => {
    if (list) {
      setLoading(false);
    }
  }, [list]);

  useEffect(() => {
    trackPage()
  }, []);

  const chooseAccount = (account: any) => {
    setLoading(true);
    getCustomerDetails(account?.customer_id)
      .then((value) => {
        setAccount({ ...account, id: value?.data?.id });
        navigate(routes.INVESTMENTS);
      })
      .catch((error) => console.log(error))
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex w-full items-center justify-center flex-col">
      <h1 className="text-2xl font-semibold">{t("listOfAccounts")}</h1>
      <Card
        hoverable
        className="flex justify-start items-start bg-op w-1/2 mt-4"
      >
        <List
          className="demo-loadmore-list w-full"
          loading={loading}
          itemLayout="horizontal"
          dataSource={list || []}
          renderItem={(item: any) => (
            <List.Item
              actions={[
                <a key="list-loadmore-more" onClick={() => chooseAccount(item)}>
                  {t("choose")}
                </a>,
              ]}
            >
              <Skeleton avatar title={false} loading={loading} active>
                <List.Item.Meta
                  avatar={
                    <Avatar
                      className="bg-[#1677ff]"
                      icon={<SolutionOutlined />}
                    />
                  }
                  title={item?.customer_name}
                  description={
                    <div>
                      <span className="mr-2">
                        {t("capitalBalance")}: {item?.capital_balance} FCFA
                      </span>
                      <span>
                        {t("unrealisedInterest")}: {item?.unrealised_interest}{" "}
                        FCFA
                      </span>
                    </div>
                  }
                />
              </Skeleton>
            </List.Item>
          )}
        />
      </Card>
    </div>
  );
};

export default App;
